import { ArcGISIdentityManager } from '@esri/arcgis-rest-request';
import { useEffect, useState } from 'react';

const localAccountKey = 'local-arcgis-account';

// Read account from local storage
function getLocalAccount(): ArcGISIdentityManager | undefined {
  const localAccount = localStorage.getItem(localAccountKey);
  if (localAccount) {
    const deserializedAccount = ArcGISIdentityManager.deserialize(localAccount);
    if (deserializedAccount.tokenExpires < new Date()) {
      localStorage.removeItem(localAccountKey);
      return undefined;
    }
    return deserializedAccount;
  }
  return undefined;
}

const useLocalAccountState = (): [
  ArcGISIdentityManager | undefined,
  React.Dispatch<React.SetStateAction<ArcGISIdentityManager | undefined>>,
] => {
  //  The application state of the account
  const [account, setAccount] = useState<ArcGISIdentityManager | undefined>(
    getLocalAccount()
  );

  // Update local state when application state changes
  useEffect(() => {
    if (account) {
      try {
        localStorage.setItem(localAccountKey, account.serialize());
      } catch {
        new Error('Could not set local account');
      }
    } else {
      // If account state is undefined, remove the local key
      localStorage.removeItem(localAccountKey);
    }
  }, [account]);

  return [account, setAccount];
};

export default useLocalAccountState;
